import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import AboutAIDay from '../components/AboutAIDay';
import WhyAIDay from '../components/WhyAIDay';
import AboutAIAnytime from '../components/AboutAIAnytime';
import FeaturedEvent from '../components/FeaturedEvent';
import PastEvents from '../components/PastEvents';
import HostAIDay from '../components/HostAIDay';
import AIGramshala from '../components/AIGramshala';

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>AI Day — Exploring Intelligence. Empowering Innovation.</title>
        <meta name="description" content="AI Day — A flagship AI initiative by AI Anytime bringing AI projects, hackathons, industry talks, and hands-on learning to universities and communities across India." />
        <meta property="og:title" content="AI Day — Exploring Intelligence. Empowering Innovation." />
        <meta property="og:description" content="A flagship AI initiative by AI Anytime bringing AI projects, hackathons, industry talks, and hands-on learning to universities and communities." />
        <meta property="og:url" content="https://aidayevents.com" />
        <meta property="og:image" content="https://aidayevents.com/images/backgrounds/GITAM_Hyderabad_Campus.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Hero />
      <AboutAIDay />
      <WhyAIDay />
      <AboutAIAnytime />
      <FeaturedEvent />
      <PastEvents />
      <HostAIDay />
      <AIGramshala />
    </div>
  );
};

export default Home;
